// tslint:disable
export var ExtauthProfileUpdateStatus;
(function (ExtauthProfileUpdateStatus) {
    // Update was successful
    ExtauthProfileUpdateStatus[ExtauthProfileUpdateStatus["Success"] = 0] = "Success";
    // Update failed
    ExtauthProfileUpdateStatus[ExtauthProfileUpdateStatus["Failed"] = 1] = "Failed";
})(ExtauthProfileUpdateStatus || (ExtauthProfileUpdateStatus = {}));
ExtauthProfileUpdateStatus['SUCCESS'] = 0;
ExtauthProfileUpdateStatus['FAILED'] = 1;
//# sourceMappingURL=ExtauthProfileUpdateStatus.js.map